import { MatDialog } from '@angular/material'
import { Component, Input, OnInit, Output } from '@angular/core'

@Component({
	selector: 'modal-reactivate-demand',
	templateUrl: './modal-reactivate-demand.component.html'
})
export class ModalReactivateDemandComponent implements OnInit {
	@Input() public close: () => void
	@Output() public cancel: boolean = true

	constructor(
		public dialog: MatDialog
	) { }

	public ngOnInit() {

		const dialogmodal = document.getElementsByClassName('mat-dialog-container')[0].id
		document.getElementById(dialogmodal).classList.remove('mat-dialog-container')
	 }


	public closeModal() {
		this.cancel = true
		this.dialog.closeAll()
	}

	public send() {
		this.cancel = false
		this.dialog.closeAll()
	}

}
